const ERRORS: Record<string, string> = {
  min: '2_0.VALIDATION.min',
  max: '2_0.VALIDATION.max',

  minExclusive: '2_0.VALIDATION.min_exclusive',
  maxExclusive: '2_0.VALIDATION.max_exclusive',

  minLength: '2_0.VALIDATION.min_length',
  maxLength: '2_0.VALIDATION.max_length',

  integer: '2_0.VALIDATION.integer',
  required: '2_0.VALIDATION.required',
  invalidRange: '2_0.VALIDATION.range',
};

export const FORM_VALIDATION_ERRORS_RESOLVER = (errorName: string) => {
  return errorName in ERRORS ? ERRORS[errorName] : '2_0.VALIDATION.default';
};
